export default __webpack_public_path__ + "static/media/event-image-3.9294962c.png";